import { jsx, jsxs } from "react/jsx-runtime";
import { InfoRoundIcon, DeleteRoundIcon, SuccessRoundIcon, CloseIcon } from "@dion-web/ui-icons";
import { styled } from "@mui/material/styles";
import isArray from "lodash/isArray";
import isString from "lodash/isString";
import isUndefined from "lodash/isUndefined";
import React, { useState } from "react";
import MBox from "../Box";
import Button, { EButtonVariants } from "../Button";
import { Icon } from "../Icon";
import ProgressBar from "../ProgressBar";
import Typography from "../Typography";
const NOTIFICATION_TOKENS = {
  // TODO: передать токены дизайнерам в фигму
  icon: {
    iconName: {
      default: InfoRoundIcon,
      info: InfoRoundIcon,
      warning: InfoRoundIcon,
      error: DeleteRoundIcon,
      success: SuccessRoundIcon
    },
    color: {
      default: "infoContent",
      info: "infoContent",
      warning: "warningContent",
      error: "errorContent",
      success: "successContent"
    }
  },
  color: {
    borderColor: {
      default: "main",
      info: "main",
      warning: "warningContent",
      error: "errorContent",
      success: "successContent"
    }
  },
  sizes: {
    width: "320px",
    height: "110px",
    border: "1px",
    borderRadius: "8px",
    paddings: {
      top: "12px",
      botton: "12px",
      right: "16px",
      left: "16px"
    },
    progressBarHeight: "4px"
  }
};
const StyledNotificationBox = styled(MBox)(({ status, theme, fullWidth }) => {
  const palette = theme.palette;
  const borderColor = palette.elevation2[NOTIFICATION_TOKENS.color.borderColor[status]];
  const wrapperWidth = fullWidth ? "100%" : NOTIFICATION_TOKENS.sizes.width;
  return {
    display: "flex",
    gap: "12px",
    backgroundColor: palette.elevation2.main,
    position: "relative",
    minWidth: wrapperWidth,
    maxWidth: wrapperWidth,
    paddingTop: NOTIFICATION_TOKENS.sizes.paddings.top,
    paddingBottom: `calc(${NOTIFICATION_TOKENS.sizes.paddings.botton} + ${NOTIFICATION_TOKENS.sizes.progressBarHeight})`,
    paddingRight: NOTIFICATION_TOKENS.sizes.paddings.right,
    paddingLeft: NOTIFICATION_TOKENS.sizes.paddings.left,
    borderRadius: NOTIFICATION_TOKENS.sizes.borderRadius,
    border: `${NOTIFICATION_TOKENS.sizes.border} solid ${borderColor}`,
    overflow: "hidden",
    boxSizing: "border-box"
  };
});
const ContentWrapper = styled(MBox)({
  display: "flex",
  flexDirection: "column",
  gap: "4px",
  width: "calc(100% - 56px)",
  justifyContent: "center"
});
const ControlsWrapper = styled(MBox)({
  display: "flex",
  flexDirection: "row",
  gap: "16px"
});
const ProgressBarWrapper = styled(MBox)({
  position: "absolute",
  bottom: "0",
  left: "0",
  right: "0",
  height: NOTIFICATION_TOKENS.sizes.progressBarHeight,
  overflow: "hidden",
  borderBottomLeftRadius: NOTIFICATION_TOKENS.sizes.borderRadius,
  borderBottomRightRadius: NOTIFICATION_TOKENS.sizes.borderRadius
});
const StyledTitle = styled(Typography)({
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  width: "100%"
});
const StyledSubtitle = styled(Typography)({
  display: "-webkit-box",
  overflow: "hidden",
  WebkitBoxOrient: "vertical",
  WebkitLineClamp: 4,
  textOverflow: "ellipsis",
  whiteSpace: "pre-line",
  width: "100%"
});
const CLOSE_BUTTON_SX = {
  position: "absolute",
  right: "8px",
  top: "8px"
};
const Notification = (props) => {
  const { title, subtitle, controls, status = "default", onClose } = props;
  const [progressVisible, setProgressVisible] = useState(true);
  const IconToUse = NOTIFICATION_TOKENS.icon.iconName[status];
  const iconColor = NOTIFICATION_TOKENS.icon.color[status];
  const isStringSubtitle = isString(subtitle);
  const [isHover, setIsHover] = useState(false);
  const showProgressbar = progressVisible && !isUndefined(props.autoHideDuration);
  const handleProgressComplete = () => {
    setProgressVisible(false);
  };
  const renderControls = () => {
    if (!controls)
      return null;
    const controlElements = isArray(controls) ? controls.slice(0, 2) : [controls];
    return /* @__PURE__ */ jsx(ControlsWrapper, { children: controlElements.map((control, index) => {
      if (React.isValidElement(control)) {
        return React.cloneElement(control, {
          ...control.props,
          size: "s",
          variant: "text",
          startIcon: void 0,
          endIcon: void 0,
          key: index
        });
      }
      return null;
    }) });
  };
  return /* @__PURE__ */ jsxs(
    StyledNotificationBox,
    {
      bg: "elevation2",
      status,
      onMouseEnter: () => setIsHover(true),
      onMouseLeave: () => setIsHover(false),
      fullWidth: props.fullWidth,
      className: props.className,
      children: [
        /* @__PURE__ */ jsx(Icon, { size: "l", icon: /* @__PURE__ */ jsx(IconToUse, {}), color: iconColor }),
        /* @__PURE__ */ jsxs(ContentWrapper, { children: [
          title && /* @__PURE__ */ jsx(StyledTitle, { variant: "subtitle3", children: title }),
          isStringSubtitle && /* @__PURE__ */ jsx(StyledSubtitle, { variant: "body2", children: subtitle }),
          renderControls()
        ] }),
        onClose && /* @__PURE__ */ jsx(
          Button,
          {
            sx: CLOSE_BUTTON_SX,
            variant: EButtonVariants.GHOST,
            startIcon: /* @__PURE__ */ jsx(CloseIcon, {}),
            size: "s",
            onClick: onClose
          }
        ),
        showProgressbar && /* @__PURE__ */ jsx(ProgressBarWrapper, { children: /* @__PURE__ */ jsx(
          ProgressBar,
          {
            autoHideDuration: props.autoHideDuration,
            status,
            isPause: isHover,
            onComplete: handleProgressComplete
          }
        ) })
      ]
    }
  );
};
var Notification_default = Notification;
export {
  Notification_default as default
};
